export default "https://static-tg.3jyx.cn/mallfe/_next/static/images/wjz-df271eba7e9dd47fc82f7aaf8bc737ed.png";